var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "request-review-form iu-card mt-4" },
    [
      _c("ListInvoiceProducts", {
        staticClass: "mb-4",
        attrs: {
          invoice: _vm.invoice,
          "show-select": !_vm.isInvoicePending,
          "is-products-invalid": _vm.isProductsInvalid,
        },
        on: {
          select: function ($event) {
            _vm.products = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "pa-4",
          attrs: { "background-color": "#f5f5f5", flat: "" },
        },
        [
          !_vm.isInvoicePending
            ? [
                _c("p", { staticClass: "rrf-title" }, [
                  _vm._v("\n        Você não concorda com:\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rrf-not-agree-with" },
                  [
                    _c("v-checkbox", {
                      attrs: {
                        value: true,
                        error: _vm.isNotAgreeInvalid,
                        color: "secondary",
                        label: "Produto da Campanha",
                      },
                      model: {
                        value: _vm.form.notAgreeWith.dmProduct,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.notAgreeWith, "dmProduct", $$v)
                        },
                        expression: "form.notAgreeWith.dmProduct",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      attrs: {
                        value: true,
                        error: _vm.isNotAgreeInvalid,
                        color: "secondary",
                        label: "Quantidade calculada",
                      },
                      model: {
                        value: _vm.form.notAgreeWith.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.notAgreeWith, "quantity", $$v)
                        },
                        expression: "form.notAgreeWith.quantity",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      attrs: {
                        value: true,
                        error: _vm.isNotAgreeInvalid,
                        color: "secondary",
                        label: "Status",
                      },
                      model: {
                        value: _vm.form.notAgreeWith.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.notAgreeWith, "status", $$v)
                        },
                        expression: "form.notAgreeWith.status",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isInvoicePending
            ? _c("p", { staticClass: "rrf-title mb-1" }, [
                _vm._v("\n      Observações\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("AppTextArea", {
            attrs: {
              rows: 4,
              v: _vm.$v.form.description,
              label: "Descreva o que não está de acordo: ",
              placeholder: "Descreva o que não está de acordo:",
              "min-length": "50",
              "max-length": "5000",
              "hide-details": "",
            },
            on: {
              focusout: function ($event) {
                return _vm.$v.form.description.$touch()
              },
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.form.description.length || "0") + "/5000"),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v("*Mínimo 50 caracteres."),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "upload-section" },
            [
              _c("input", {
                ref: "uploadInput",
                attrs: {
                  accept: ".PDF,.JPG,.JPEG,.PNG",
                  type: "file",
                  hidden: "",
                  multiple: "",
                },
                on: { change: _vm.getRequestReviewFiles },
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { outline: "", color: "secondary", flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.uploadInput.click()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons mr-2" }, [
                    _vm._v("cloud_upload"),
                  ]),
                  _vm._v(" Importar arquivos\n      "),
                ]
              ),
              _vm._v(" "),
              _c("small", { staticClass: "gray--text mb-2" }, [
                _vm._v("Somente arquivos .PDF, .JPG, .JPEG ou .PNG"),
              ]),
              _vm._v(" "),
              _vm.files.length
                ? _c("div", { staticClass: "selected-files" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.files.map((file) => file.name).join(", ")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "submit-box" },
            [
              _c(
                "v-btn",
                {
                  attrs: { outline: "", color: "secondary", flat: "" },
                  on: { click: _vm.cancelRequestReview },
                },
                [_vm._v("\n        Voltar\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.confirmRequestReview },
                },
                [_vm._v("\n        Solicitar revisão\n      ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }